import { render, staticRenderFns } from "./InstagramContactList.vue?vue&type=template&id=096b989a&scoped=true"
import script from "./InstagramContactList.vue?vue&type=script&lang=js"
export * from "./InstagramContactList.vue?vue&type=script&lang=js"
import style0 from "./InstagramContactList.vue?vue&type=style&index=0&id=096b989a&prod&lang=scss"
import style1 from "./InstagramContactList.vue?vue&type=style&index=1&id=096b989a&prod&scoped=true&lang=scss"
import style2 from "./InstagramContactList.vue?vue&type=style&index=2&id=096b989a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b989a",
  null
  
)

export default component.exports